var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreebie1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.058 10.8149C9.5841 11.3573 8.97867 11.7688 8.29987 12.0097C7.62462 12.2485 6.89876 12.3071 6.19395 12.1797C5.52914 12.105 4.89528 11.8583 4.35482 11.464C3.81119 11.0676 3.37855 10.5382 3.09841 9.92649C1.9764 7.04948 4.07176 4.85619 4.49253 4.43741C4.85163 4.15751 5.13079 3.78808 5.302 3.3662C5.4738 2.94266 5.53203 2.4816 5.47094 2.02865C6.12256 2.7019 8.87792 4.49303 7.68305 8.65823C8.64872 8.14038 9.51685 7.14993 9.89052 5.33691C10.6175 6.07881 11.6875 8.84777 10.058 10.8149Z",
    stroke: "#046E0D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreebie1);
export default __webpack_public_path__ + "static/media/freebie1.c8a32d41e28a59050e5f00402d2b2b53.svg";
export { ForwardRef as ReactComponent };